import defaultAxios from 'axios';
import UIkit from 'uikit';
import {getFormData} from 'fmjs';

export const axiosConfig = {
  headers: {
    Accept: 'application/json; charset=utf-8',
    'Content-Type': 'application/json; charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest',
  },
};

export const axios = defaultAxios.create(axiosConfig);

export const getCsrf = async() => {
  const {data} = await axios.get('/actions/users/session-info');

  return data.csrfTokenValue;
};

export const catchError = ({response}) => {
  const message = response?.data?.error || 'Something went wrong.';

  UIkit.notification({
    message,
    status: 'warning',
    timeout: 5000,
  });

  console.error(response);
};

export const submitForm = async(form, success) => {
  const formData = getFormData(form, 'formData');

  formData.append('CRAFT_CSRF_TOKEN', await getCsrf());

  axios.post('', formData)
  .then(success)
  .catch(catchError);
};
